import { Button, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { FC, useState } from 'react';
import { Dialog } from '../../dialog/dialog.styles';

interface FeatureNotAllowedModalProps {
  onClose: () => void;
}

export const FeatureNotAllowedModal: FC<FeatureNotAllowedModalProps> = (props) => {
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    props.onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Unable to complete action</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Full access to to this feature is outside of your subscription or user role.
          <br />
          <br />
          For a demo or more information, visit:{' '}
          <a target="_blank" href="https://www.revenuewell.com/schedule-a-demo" rel="noreferrer">
            https://www.revenuewell.com/schedule-a-demo
          </a>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Ok</Button>
      </DialogActions>
    </Dialog>
  );
};
